import { useCallback, useEffect, useState } from 'react';
import { getRecaudacionDiaria } from '../services/recaudacionDiariaServices';
import { RecaudacionDiariaReportDto } from '../models/recaudacionDiara';
import { selectorTransversal } from '../../../../dtos/selector';
import { getUsuarios } from '../../../../services/servicesUsuarios';
import { ListResponseDto } from '../../../../dtos/ListResponseDto';
import { AxiosResponse } from 'axios';

export function useRecaudacionDiaria() {
    const [data, setData] = useState<RecaudacionDiariaReportDto[]>([]);
    const [user, setUser] = useState<selectorTransversal[]>([]);

    const fetchData = useCallback(async (fechaInicio: Date, fechaFin: Date, usuario: string) => {

        const response : AxiosResponse<ListResponseDto<RecaudacionDiariaReportDto>> = await getRecaudacionDiaria(fechaInicio, fechaFin, usuario);
        if (response.status === 200) {
            setData(response.data.items);
        }

    }, []);

    const fetchUsers = useCallback(async () => {
        const response: AxiosResponse<ListResponseDto<selectorTransversal>> = await getUsuarios();
        if (response.status === 200) {
            setUser(response.data.items);
        }
    }, []);

    return { data, fetchData, user, fetchUsers };
}